export interface UVTransform {
  repeat: { x: number; y: number };
  offset: { x: number; y: number };
}

/**
 * Texture UV repeat/offset that makes a `srcAspect` texture cover a `dstAspect` viewport without
 * distortion (CSS `object-fit: cover`), centred. Used to cover-fit the live camera-feed background.
 * Aspect = width / height.
 */
export function coverFitUVTransform(srcAspect: number, dstAspect: number): UVTransform {
  if (srcAspect > dstAspect) {
    const repeatX = dstAspect / srcAspect; // source too wide → sample a narrower slice of width
    return { repeat: { x: repeatX, y: 1 }, offset: { x: (1 - repeatX) / 2, y: 0 } };
  }

  const repeatY = srcAspect / dstAspect; // source too tall (or equal) → crop top/bottom
  return { repeat: { x: 1, y: repeatY }, offset: { x: 0, y: (1 - repeatY) / 2 } };
}
